module.exports = __webpack_public_path__ + "img/04.46ea05cb.jpg";